export enum LocationType {
    City = 'city',
    Department = 'department',
    PostalCode = 'postal-code'
}

export interface CityLocation {
    type: LocationType.City,
    label: string,
    name: string,
    townId: number,
    postalCode?: string,
    insee: string,
}

export interface DepartmentLocation {
    type: LocationType.Department,
    label: string,
    name: string,
    departmentId: string,
}

export interface PostalCodeLocation {
    type: LocationType.PostalCode,
    label: string,
    postalCode: string
}

export type Location =
    | CityLocation
    | DepartmentLocation
    | PostalCodeLocation
